import { useDecisionMakerProfilePageData } from 'src/app/pages/decisionMakerProfile/pageContext';

export function useResponsivenessScoreEnabled(): boolean {
	const { responsivenessData: data } = useDecisionMakerProfilePageData();

	return data.isVisible;
}
